// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37Bo-","location":"Header_location__Q5lhM"};